var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18743 14.9042C11.7733 14.9042 14.6803 11.9973 14.6803 8.41147C14.6803 4.82561 11.7733 1.9187 8.18743 1.9187C4.60153 1.9187 1.69458 4.82561 1.69458 8.41147C1.69458 11.9973 4.60153 14.9042 8.18743 14.9042Z",
    stroke: "#25211E",
    strokeWidth: 2.08697,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3034 16.5265L12.7729 12.9961",
    stroke: "#25211E",
    strokeWidth: 2.08697,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSearchIcon);
export default __webpack_public_path__ + "static/media/mobile_search_icon.56cdb1aaeb0e963643f2bbae68d7ce65.svg";
export { ForwardRef as ReactComponent };